import PrivateRoute, { Router } from '@Components/app-layout/PrivateRoute';

import MetaFieldsGrid from '../components/Grid';
import { MetaFieldProvider } from '../store';

import MetaFieldFormLayout from './Form';

export default function MetaFieldsGridLayout() {
  return <MetaFieldProvider>
    <MetaFieldsGrid />
    <Router>
      <PrivateRoute path={['/settings/meta-fields/add', '/settings/meta-fields/:id']} component={MetaFieldFormLayout} />
    </Router>
  </MetaFieldProvider>;
}
